// extracted by mini-css-extract-plugin
export default {"recipeSearchCategoryFilterString":"xVQwkBpI6NBp14qkWUQ4-RecipeSearchCategoryFilterString-recipeSearchCategoryFilterString"};